import * as marietta3d from '../..';
import * as marietta from '../../../marietta';

/*
* Wall
*
*/
export default class AutoObjWall {
    public item: string;

    public type: number;

    public htypeLeft: number;

    public htypeRight: number;

    public leftHeya: marietta3d.AutoGen.object.AutoObjRoom;

    public rightHeya: marietta3d.AutoGen.object.AutoObjRoom;

    public flr: number;

    public p1pos: number;

    public p2pos: number;

    public OutSide: boolean;

    constructor(type: number, left: number, right: number, flr: number, p1: number, p2: number) {
      this.item = 'wal';
      this.type = type; /* 0:Nothing, 1:Full, 2:HandRail, 3:DownWall */
      this.htypeLeft = left;
      this.htypeRight = right;
      this.leftHeya = null;
      this.rightHeya = null;
      this.flr = flr;
      this.p1pos = p1;
      this.p2pos = p2;
      this.OutSide = false;
    }

    /*
    * 指定された位置の頂点と次の頂点を Line で返す
    * 注意：Line の座標は多角形と別インスタンス
    */
    public CopyLine(PlanPnt: marietta3d.AutoGen.utils.RoomPointArray): marietta3d.AutoGen.utils.RoomEdge {
      const ln = new marietta3d.AutoGen.utils.RoomEdge();
      ln.CopyPointFrom(PlanPnt[this.p1pos], PlanPnt[this.p2pos]);
      return ln;
    }

    /*
    * 指定された位置の頂点と次の頂点を Line で返す
    * 注意：Line の座標は多角形のインスタンスを参照している
    */
    public GetLine(PlanPnt: marietta3d.AutoGen.utils.RoomPointArray): marietta3d.AutoGen.utils.RoomEdge {
      const ln = new marietta3d.AutoGen.utils.RoomEdge();
      ln.GetPointFrom(PlanPnt[this.p1pos], PlanPnt[this.p2pos]);
      return ln;
    }

    //
    // 両サイドの部屋タイプから外壁かどうか判断する
    //
    public CheckWallType() {
      /*----------------*/
      if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.BALCONY) {
        if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.UNKNOWN) {
          this.OutSide = true;
        } else {
          this.OutSide = true;
        }
        return;
      }

      if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.BALCONY) {
        if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.UNKNOWN) {
          this.OutSide = true;
        } else {
          this.OutSide = true;
        }
        return;
      }

      /*----------------*/
      if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.PORCH) {
        if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.UNKNOWN) {
          this.OutSide = true;
        } else {
          this.OutSide = true;
        }
        return;
      }

      if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.PORCH) {
        if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.UNKNOWN) {
          this.OutSide = true;
        } else {
          this.OutSide = true;
        }
        return;
      }

      /*----------------*/
      if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.LIVING) {
        if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.KITCHEN) {
          this.OutSide = false;
          return;
        }
      }

      if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.LIVING) {
        if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.KITCHEN) {
          this.OutSide = false;
          return;
        }
      }

      /*----------------*/
      if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.DINING) {
        if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.KITCHEN) {
          this.OutSide = false;
          return;
        }
      }
      if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.DINING) {
        if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.KITCHEN) {
          this.OutSide = false;
          return;
        }
      }

      /*----------------*/
      if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.HALLWAY) {
        if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.ENTRANCE) {
          this.OutSide = false;
          return;
        }
      }

      if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.HALLWAY) {
        if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.ENTRANCE) {
          this.OutSide = false;
          return;
        }
      }

      /*----------------*/
      if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.HALLWAY) {
        if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.STAIR) {
          this.OutSide = false;
          return;
        }
      }

      if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.HALLWAY) {
        if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.STAIR) {
          this.OutSide = false;
          return;
        }
      }

      /*----------------*/
      if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.STAIR) {
        if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.STAIR) {
          this.OutSide = false;
          return;
        }
      }

      if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.STAIR) {
        if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.STAIR) {
          this.OutSide = false;
          return;
        }
      }

      /*----------------*/
      if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.STAIR) {
        if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.WELLHOLE) {
          this.OutSide = false;
          return;
        }
      }

      if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.STAIR) {
        if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.WELLHOLE) {
          this.OutSide = false;
          return;
        }
      }

      /*----------------*/
      if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.WELLHOLE) {
        if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.WELLHOLE) {
          this.OutSide = false;
          return;
        }
      }

      if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.WELLHOLE) {
        if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.WELLHOLE) {
          this.OutSide = false;
          return;
        }
      }

      /*----------------*/
      if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.UNKNOWN) {
        this.OutSide = true;
        return;
      }

      if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.UNKNOWN) {
        this.OutSide = true;
        return;
      }

      this.OutSide = false;
    }

    //----
    // 部屋のタイプから壁の色を決める
    //
    private wallColor(): string {
      const clBlack = '#000';
      const clBlue = '#00f';
      const clYellow = '#0ff';
      const clBrawn = '#a00';
      // const clGray = '#ccc';
      this.CheckWallType();
      if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.BALCONY) {
        if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.UNKNOWN) {
          return clBrawn;
        }
        return clYellow;
      }
      if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.BALCONY) {
        if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.UNKNOWN) {
          return clBrawn;
        }
        return clYellow;
      }
      if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.PORCH) {
        if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.UNKNOWN) {
          return clBlack;
        }
        return clYellow;
      }
      if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.PORCH) {
        if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.UNKNOWN) {
          return clBlack;
        }
        return clYellow;
      }
      if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.LIVING) {
        if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.KITCHEN) {
          return clBlack;
        }
      }
      if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.LIVING) {
        if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.KITCHEN) {
          return clBlack;
        }
      }
      if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.DINING) {
        if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.KITCHEN) {
          return clBlack;
        }
      }
      if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.DINING) {
        if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.KITCHEN) {
          return clBlack;
        }
      }
      if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.HALLWAY) {
        if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.ENTRANCE) {
          return clBlack;
        }
      }
      if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.HALLWAY) {
        if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.ENTRANCE) {
          return clBlack;
        }
      }
      if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.HALLWAY) {
        if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.STAIR) {
          return clBlack;
        }
      }
      if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.HALLWAY) {
        if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.STAIR) {
          return clBlack;
        }
      }
      if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.STAIR) {
        if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.STAIR) {
          return clBlack;
        }
      }
      if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.STAIR) {
        if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.STAIR) {
          return clBlack;
        }
      }
      if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.STAIR) {
        if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.WELLHOLE) {
          return clBlack;
        }
      }
      if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.STAIR) {
        if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.WELLHOLE) {
          return clBlack;
        }
      }
      if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.WELLHOLE) {
        if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.WELLHOLE) {
          return clBlack;
        }
      }
      if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.WELLHOLE) {
        if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.WELLHOLE) {
          return clBlack;
        }
      }
      if (this.htypeLeft === marietta3d.AutoGen.object.HTYPE.UNKNOWN) {
        return clYellow;
      }
      if (this.htypeRight === marietta3d.AutoGen.object.HTYPE.UNKNOWN) {
        return clYellow;
      }
      return clBlue;
    }

    /*
    * Wall draw
    *
    */
    public draw(sc: marietta3d.AutoGen.Scale, ctx: CanvasRenderingContext2D, PlanPnt: marietta3d.AutoGen.utils.RoomPointArray): void {
      /* const clBlue = '#00f';
        const clBrawn = '#a00';
        const clGray = '#ccc';
        const clRed = '#fff'; */
      const clBlack = '#000';
      const cl = this.wallColor();
      if (cl === clBlack) return;
      const ln = this.CopyLine(PlanPnt);
      ln.IncreaseLine(-10, -10);
      const ip1 = sc.ConvertToCanvas(ln.s);
      const ip2 = sc.ConvertToCanvas(ln.e);
      ctx.beginPath();
      ctx.strokeStyle = cl;
      ctx.lineWidth = 3;
      ctx.moveTo(ip1.x, ip1.y);
      ctx.lineTo(ip2.x, ip2.y);
      ctx.stroke();
    }

    /*
    * IsHit
    *
    */
    public IsHit(p: marietta.core.Point, PlanPnt: marietta3d.AutoGen.utils.RoomPointArray): boolean {
      const ln = this.CopyLine(PlanPnt);
      if (ln.DistancePtoEdge(p) < 10) {
        return true;
      }
      return false;
    }

    /*
    * HTYPE Name
    *
    */
    public static htypeName(type: number): string {
      let name;
      switch (type) {
        case marietta3d.AutoGen.object.HTYPE.BALCONY: name = 'バルコニー'; break;
        case marietta3d.AutoGen.object.HTYPE.BATHROOM: name = '浴室'; break;
        case marietta3d.AutoGen.object.HTYPE.CLOSET: name = '収納'; break;
        case marietta3d.AutoGen.object.HTYPE.DINING: name = 'ダイニング'; break;
        case marietta3d.AutoGen.object.HTYPE.ENTRANCE: name = '玄関'; break;
        case marietta3d.AutoGen.object.HTYPE.FLORING: name = '洋室'; break;
        case marietta3d.AutoGen.object.HTYPE.HALLWAY: name = '廊下'; break;
        case marietta3d.AutoGen.object.HTYPE.KITCHEN: name = 'キッチン'; break;
        case marietta3d.AutoGen.object.HTYPE.LIVING: name = 'リビング'; break;
        case marietta3d.AutoGen.object.HTYPE.PORCH: name = 'ポーチ'; break;
        case marietta3d.AutoGen.object.HTYPE.STAIR: name = '階段'; break;
        case marietta3d.AutoGen.object.HTYPE.TOILET: name = 'トイレ'; break;
        case marietta3d.AutoGen.object.HTYPE.TOKONOMA: name = '床の間'; break;
        case marietta3d.AutoGen.object.HTYPE.WASHROOM: name = '洗面'; break;
        case marietta3d.AutoGen.object.HTYPE.WASITU: name = '和室'; break;
        case marietta3d.AutoGen.object.HTYPE.WELLHOLE: name = '吹抜'; break;
        case marietta3d.AutoGen.object.HTYPE.UNKNOWN: name = '外部'; break;
        default: break;
      }
      return name;
    }
}
